import React from "react";
import { ISearchResults } from "./interface/iSearchResults";
import { AnalyticsContext } from "./context/analyticsContext";
import SearchForm from "./src/searchForm";
import SearchResults from "./src/searchResults";
import AppointmentList from "./src/appointmentList";
import Section from "../../../components/section/section";

const AnalyticsContainer = (): React.JSX.Element => {
  const {
    searchResults,
    isLoading,
  }: {
    searchResults: ISearchResults;
    isLoading: boolean;
  } = React.useContext(AnalyticsContext);

  return (
    <Section>
      <SearchForm />
      {!isLoading && searchResults.appointmentList && <SearchResults />}
      {!isLoading &&
        searchResults.appointmentList &&
        searchResults.appointmentList.appointments.length > 0 && (
          <AppointmentList />
        )}
    </Section>
  );
};

export default AnalyticsContainer;
